var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "status-badge", class: _vm.currentStatus.cls },
    [_c("vwc-icon", { attrs: { type: _vm.currentStatus.icon } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }